module.exports = __webpack_public_path__ + "img/LIGHTBOX_CYBER_BI_800X800_4.4fe512eb.jpg";